/**
 * Use this to correctly display popup when the popup goes out of its parent boundaries.
 * Usage : <Popup {...ensureCorrectPopupPosition} />
 */
export const ensureCorrectPopupPosition: { popperModifiers: any[] } = {
  popperModifiers: [
    {
      name: "preventOverflow",
      options: { boundariesElement: "window" },
    },
  ],
}
